//# sourceMappingURL=cell_mapping.mjs.map
/// <reference types="./cell_mapping.d.mts" />
import * as $json from "../../../gleam_json/gleam/json.mjs";
import * as $decode from "../../../gleam_stdlib/gleam/dynamic/decode.mjs";
import * as $option from "../../../gleam_stdlib/gleam/option.mjs";
import * as $decrypt from "../../decrypt.mjs";
import { toList, CustomType as $CustomType } from "../../gleam.mjs";

export class LongAnswerTarget extends $CustomType {
  constructor(target) {
    super();
    this.target = target;
  }
}
export const CellEdge$LongAnswerTarget = (target) =>
  new LongAnswerTarget(target);
export const CellEdge$isLongAnswerTarget = (value) =>
  value instanceof LongAnswerTarget;
export const CellEdge$LongAnswerTarget$target = (value) => value.target;
export const CellEdge$LongAnswerTarget$0 = (value) => value.target;

export class MultipleChoiceAnswerTarget extends $CustomType {
  constructor(target, choices) {
    super();
    this.target = target;
    this.choices = choices;
  }
}
export const CellEdge$MultipleChoiceAnswerTarget = (target, choices) =>
  new MultipleChoiceAnswerTarget(target, choices);
export const CellEdge$isMultipleChoiceAnswerTarget = (value) =>
  value instanceof MultipleChoiceAnswerTarget;
export const CellEdge$MultipleChoiceAnswerTarget$target = (value) =>
  value.target;
export const CellEdge$MultipleChoiceAnswerTarget$0 = (value) => value.target;
export const CellEdge$MultipleChoiceAnswerTarget$choices = (value) =>
  value.choices;
export const CellEdge$MultipleChoiceAnswerTarget$1 = (value) => value.choices;

export class ContextSource extends $CustomType {
  constructor(target) {
    super();
    this.target = target;
  }
}
export const CellEdge$ContextSource = (target) => new ContextSource(target);
export const CellEdge$isContextSource = (value) =>
  value instanceof ContextSource;
export const CellEdge$ContextSource$target = (value) => value.target;
export const CellEdge$ContextSource$0 = (value) => value.target;

export class InstructionSource extends $CustomType {
  constructor(target) {
    super();
    this.target = target;
  }
}
export const CellEdge$InstructionSource = (target) =>
  new InstructionSource(target);
export const CellEdge$isInstructionSource = (value) =>
  value instanceof InstructionSource;
export const CellEdge$InstructionSource$target = (value) => value.target;
export const CellEdge$InstructionSource$0 = (value) => value.target;

export class ParentQuestion extends $CustomType {
  constructor(target) {
    super();
    this.target = target;
  }
}
export const CellEdge$ParentQuestion = (target) => new ParentQuestion(target);
export const CellEdge$isParentQuestion = (value) =>
  value instanceof ParentQuestion;
export const CellEdge$ParentQuestion$target = (value) => value.target;
export const CellEdge$ParentQuestion$0 = (value) => value.target;

export class PreviousQuestion extends $CustomType {
  constructor(target) {
    super();
    this.target = target;
  }
}
export const CellEdge$PreviousQuestion = (target) =>
  new PreviousQuestion(target);
export const CellEdge$isPreviousQuestion = (value) =>
  value instanceof PreviousQuestion;
export const CellEdge$PreviousQuestion$target = (value) => value.target;
export const CellEdge$PreviousQuestion$0 = (value) => value.target;

export class NumberingSource extends $CustomType {
  constructor(target) {
    super();
    this.target = target;
  }
}
export const CellEdge$NumberingSource = (target) => new NumberingSource(target);
export const CellEdge$isNumberingSource = (value) =>
  value instanceof NumberingSource;
export const CellEdge$NumberingSource$target = (value) => value.target;
export const CellEdge$NumberingSource$0 = (value) => value.target;

export class HeaderSource extends $CustomType {
  constructor(target, level) {
    super();
    this.target = target;
    this.level = level;
  }
}
export const CellEdge$HeaderSource = (target, level) =>
  new HeaderSource(target, level);
export const CellEdge$isHeaderSource = (value) => value instanceof HeaderSource;
export const CellEdge$HeaderSource$target = (value) => value.target;
export const CellEdge$HeaderSource$0 = (value) => value.target;
export const CellEdge$HeaderSource$level = (value) => value.level;
export const CellEdge$HeaderSource$1 = (value) => value.level;

/**
 * Carried on an `answer_textual` cell's own mapping (not the question's):
 * which cell supplies the complementary question it answers, when the
 * owning question has more than one textual answer (SL-9) — e.g. a column
 * header naming what this particular answer column is about.
 */
export class AnswerHeaderSource extends $CustomType {
  constructor(target) {
    super();
    this.target = target;
  }
}
export const CellEdge$AnswerHeaderSource = (target) =>
  new AnswerHeaderSource(target);
export const CellEdge$isAnswerHeaderSource = (value) =>
  value instanceof AnswerHeaderSource;
export const CellEdge$AnswerHeaderSource$target = (value) => value.target;
export const CellEdge$AnswerHeaderSource$0 = (value) => value.target;

export const CellEdge$target = (value) => value.target;

export class QuestionCellMapping extends $CustomType {
  constructor(schema_version, sheet_name, anchor, edges, cell_type) {
    super();
    this.schema_version = schema_version;
    this.sheet_name = sheet_name;
    this.anchor = anchor;
    this.edges = edges;
    this.cell_type = cell_type;
  }
}
export const QuestionCellMapping$QuestionCellMapping = (schema_version, sheet_name, anchor, edges, cell_type) =>
  new QuestionCellMapping(schema_version, sheet_name, anchor, edges, cell_type);
export const QuestionCellMapping$isQuestionCellMapping = (value) =>
  value instanceof QuestionCellMapping;
export const QuestionCellMapping$QuestionCellMapping$schema_version = (value) =>
  value.schema_version;
export const QuestionCellMapping$QuestionCellMapping$0 = (value) =>
  value.schema_version;
export const QuestionCellMapping$QuestionCellMapping$sheet_name = (value) =>
  value.sheet_name;
export const QuestionCellMapping$QuestionCellMapping$1 = (value) =>
  value.sheet_name;
export const QuestionCellMapping$QuestionCellMapping$anchor = (value) =>
  value.anchor;
export const QuestionCellMapping$QuestionCellMapping$2 = (value) =>
  value.anchor;
export const QuestionCellMapping$QuestionCellMapping$edges = (value) =>
  value.edges;
export const QuestionCellMapping$QuestionCellMapping$3 = (value) => value.edges;
export const QuestionCellMapping$QuestionCellMapping$cell_type = (value) =>
  value.cell_type;
export const QuestionCellMapping$QuestionCellMapping$4 = (value) =>
  value.cell_type;

export function coordinates_decoder() {
  return $decode.field(
    "x",
    $decode.int,
    (x) => {
      return $decode.field(
        "y",
        $decode.int,
        (y) => { return $decode.success([x, y]); },
      );
    },
  );
}

export function edge_decoder() {
  return $decrypt.optional_field(
    "choices",
    $decode.list($decode.string),
    (choices) => {
      let choices$1 = $option.unwrap(choices, toList([]));
      return $decode.field(
        "role",
        $decode.string,
        (role) => {
          return $decode.then$(
            (() => {
              if (role === "long_answer_target") {
                return $decode.success(
                  (var0) => { return new LongAnswerTarget(var0); },
                );
              } else if (role === "context_source") {
                return $decode.success(
                  (var0) => { return new ContextSource(var0); },
                );
              } else if (role === "instruction_source") {
                return $decode.success(
                  (var0) => { return new InstructionSource(var0); },
                );
              } else if (role === "parent_question") {
                return $decode.success(
                  (var0) => { return new ParentQuestion(var0); },
                );
              } else if (role === "previous_question") {
                return $decode.success(
                  (var0) => { return new PreviousQuestion(var0); },
                );
              } else if (role === "numbering_source") {
                return $decode.success(
                  (var0) => { return new NumberingSource(var0); },
                );
              } else if (role === "answer_header_source") {
                return $decode.success(
                  (var0) => { return new AnswerHeaderSource(var0); },
                );
              } else if (role === "header_source") {
                return $decrypt.optional_field(
                  "level",
                  $decode.int,
                  (level) => {
                    return $decode.success(
                      (t) => { return new HeaderSource(t, level); },
                    );
                  },
                );
              } else if (role === "multiple_choice_answer_target") {
                return $decode.success(
                  (_capture) => {
                    return new MultipleChoiceAnswerTarget(_capture, choices$1);
                  },
                );
              } else if (role === "answer_target") {
                return $decode.field(
                  "answer_kind",
                  $decode.string,
                  (kind) => {
                    if (kind === "long") {
                      return $decode.success(
                        (var0) => { return new LongAnswerTarget(var0); },
                      );
                    } else if (kind === "multiple_choice") {
                      return $decode.success(
                        (_capture) => {
                          return new MultipleChoiceAnswerTarget(
                            _capture,
                            choices$1,
                          );
                        },
                      );
                    } else {
                      return $decode.failure(
                        (var0) => { return new LongAnswerTarget(var0); },
                        "Role",
                      );
                    }
                  },
                );
              } else {
                return $decode.failure(
                  (var0) => { return new LongAnswerTarget(var0); },
                  "Role",
                );
              }
            })(),
            (role) => {
              return $decode.field(
                "target",
                coordinates_decoder(),
                (target) => { return $decode.success(role(target)); },
              );
            },
          );
        },
      );
    },
  );
}

export function decoder() {
  return $decode.field(
    "schema_version",
    $decode.int,
    (schema_version) => {
      return $decode.field(
        "sheet_name",
        $decode.string,
        (sheet_name) => {
          return $decode.field(
            "anchor",
            coordinates_decoder(),
            (anchor) => {
              return $decode.field(
                "edges",
                $decode.list(edge_decoder()),
                (edges) => {
                  return $decrypt.optional_field(
                    "cell_type",
                    $decode.string,
                    (cell_type) => {
                      let cell_type$1 = $option.unwrap(cell_type, "question");
                      return $decode.success(
                        new QuestionCellMapping(
                          schema_version,
                          sheet_name,
                          anchor,
                          edges,
                          cell_type$1,
                        ),
                      );
                    },
                  );
                },
              );
            },
          );
        },
      );
    },
  );
}

export function encode_edge(edge) {
  let $ = edge.target;
  let x = $[0];
  let y = $[1];
  let target = $json.object(toList([["x", $json.int(x)], ["y", $json.int(y)]]));
  if (edge instanceof LongAnswerTarget) {
    return $json.object(
      toList([["role", $json.string("long_answer_target")], ["target", target]]),
    );
  } else if (edge instanceof MultipleChoiceAnswerTarget) {
    let choices = edge.choices;
    return $json.object(
      toList([
        ["role", $json.string("multiple_choice_answer_target")],
        ["target", target],
        ["choices", $json.array(choices, $json.string)],
      ]),
    );
  } else if (edge instanceof ContextSource) {
    return $json.object(
      toList([["role", $json.string("context_source")], ["target", target]]),
    );
  } else if (edge instanceof InstructionSource) {
    return $json.object(
      toList([["role", $json.string("instruction_source")], ["target", target]]),
    );
  } else if (edge instanceof ParentQuestion) {
    return $json.object(
      toList([["role", $json.string("parent_question")], ["target", target]]),
    );
  } else if (edge instanceof PreviousQuestion) {
    return $json.object(
      toList([["role", $json.string("previous_question")], ["target", target]]),
    );
  } else if (edge instanceof NumberingSource) {
    return $json.object(
      toList([["role", $json.string("numbering_source")], ["target", target]]),
    );
  } else if (edge instanceof HeaderSource) {
    let level = edge.level;
    return $json.object(
      toList([
        ["role", $json.string("header_source")],
        ["target", target],
        ["level", $json.nullable(level, $json.int)],
      ]),
    );
  } else {
    return $json.object(
      toList([
        ["role", $json.string("answer_header_source")],
        ["target", target],
      ]),
    );
  }
}

export function encode(mapping) {
  let $ = mapping.anchor;
  let x = $[0];
  let y = $[1];
  return $json.object(
    toList([
      ["schema_version", $json.int(mapping.schema_version)],
      ["sheet_name", $json.string(mapping.sheet_name)],
      [
        "anchor",
        $json.object(toList([["x", $json.int(x)], ["y", $json.int(y)]])),
      ],
      ["edges", $json.array(mapping.edges, encode_edge)],
      ["cell_type", $json.string(mapping.cell_type)],
    ]),
  );
}
